
import { navigationItems } from "../navigation/navigation-items";
import { handleNavClick, handleOfficialDownloadClick } from "./analytics";
import { Trophy } from "lucide-react";

const NavigationColumns = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
      <div className="lg:col-span-1">
        <div className="space-y-4">
          <img 
            src="/lovable-uploads/Front-Runner-Logo.png" 
            alt="Front Runner: Racehorse Manager Logo" 
            className="h-12 w-auto"
          />
          <div className="space-y-2">
            <p className="text-white/60 text-sm">
              Step into the world of elite horse racing, where strategy meets speed.
            </p>
          </div>
        </div>
      </div>

      <div className="md:flex md:justify-end">
        <div className="text-left">
          <h3 className="text-racing-orange font-bold mb-4 uppercase text-sm">Learn</h3>
          <ul className="space-y-3">
            {navigationItems.learn.filter(item => item.title !== "The Winners Circle").map((item) => (
              <li key={item.title}>
                <a 
                  href={item.href}
                  onClick={() => handleNavClick('learn', item.title)}
                  className="text-white hover:text-racing-accent transition-colors text-sm"
                >
                  {item.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="md:flex md:justify-end">
        <div className="text-left">
          <h3 className="text-racing-orange font-bold mb-4 uppercase text-sm">Play</h3>
          <ul className="space-y-3">
            {navigationItems.play.map((item) => (
              <li key={item.title}>
                <a 
                  href={item.href}
                  onClick={() => handleNavClick('play', item.title)}
                  className="text-white hover:text-racing-accent transition-colors text-sm"
                >
                  {item.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="md:flex md:justify-end">
        <div className="text-left">
          <h3 className="text-racing-orange font-bold mb-4 uppercase text-sm">Download</h3>
          <a
            href="https://play.google.com/apps/testing/com.RTz.TWCGame"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleOfficialDownloadClick}
            className="block"
          >
            <img
              alt="Get Front Runner: Racehorse Manager on Google Play"
              src="/lovable-uploads/070e8c0b-dc54-4dbf-b45e-f848dfc7624e.png"
              className="h-[42px] w-auto"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default NavigationColumns;
